import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';


@Component({
  selector: 'app-specialty-table',
  templateUrl: './specialty-table.component.html',
  styleUrls: ['./specialty-table.component.sass']
})
export class SpecialtyTableComponent extends BaseListDirective {

  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'FORM.NAME', 300, { frozen: true })];
  override title = 'FORM.SPECIALTY';
  override filterableFields = []
  override keys = {
    primary_key: 'user_post_id',
    label: 'name_'
  }
  override filename = 'FORM.SPECIALTY';

  override getList(): void {
    this.query(this.data.core.specialties()).subscribe()
  }

  override handleRows(data: any): void {
    console.log(data);
    super.handleRows(data);
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.specialtyDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }
}
